import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../components/card/card';
import { useDispatch, useSelector } from 'react-redux';
import { getListLivePeople } from '../redux/action/liveDetectionAction';
import { useLocation } from 'react-router-dom';
import { getRoleModuleById } from '../redux/action/roleModuleAction';
import findItem from '../helperFindPath';

const LivePeopleDetection = () => {
	const { dataLiveCount } = useSelector((state) => state.liveDetection );
  const [components, setComponents] = useState([])
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth)
	const param = {
		token: user.access_token,
	}
	useEffect(() => {
		dispatch(getListLivePeople(param));
	  }, []);

  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')

  const [delayedRender, setDelayedRender] = useState([]);

  useEffect(() => {
    if(dataLiveCount.length > 0){
      dataLiveCount.map((key, index)=>{
        setTimeout(()=>{
          addComponent(key,index)
        }, index * 1000)
      })
    }
  }, [dataLiveCount]);
  const addComponent = (key, index) => {
    setComponents(prevComponents => {
      const newComponent = (
          <Card className= 'mb-3'>
            <CardHeader>
              <span> {key.detailCamera.location + " - " + key.detailSite.nameSite } </span>
            </CardHeader>
            <CardBody>
              <img src={'http://103.165.198.186:5001/stream/'+key.id} alt='' style={{ width: '100%'}}/>
            </CardBody>
          </Card>
      );
      return [...prevComponents, newComponent];
    });
  };

  // const chunkedDelayedRender = Array.from(
  //   { length: Math.ceil(delayedRender.length / 2) },
  //   (_, index) => delayedRender.slice(index * 2, index * 2 + 2)
  // );
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      // console.log(findPath)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }else{
        setDataObjPath('403')
      }
    }
  },[dataRoleModuleSidebar])

  if(dataObjPath === ''){
    return (
      null
    )
  }else if(dataObjPath === '403'){
    return (
      <div>
        <h2>403: Forbidden</h2>
        <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
      </div>
    )
  }else{
	return (
		<div>
			{dataByIdRoleModule.read ? (
				<div className="row">
          {components.map((component, index) => (
            <div className="col-md-4" key={index}>
              {component}
            </div>
          ))}
					{/* {dataLiveCount &&
					dataLiveCount.length > 0 &&
					dataLiveCount.map((stat, index) => (
						<div className="col-md-4" style={{ paddingBottom: '10px'}}>
							<Card className= 'mb-3'>
								<CardHeader>
									<span> {stat.detailCamera.location + " - " + stat.detailSite.nameSite } </span>
								</CardHeader>
								<CardBody>
									<img src={'http://103.165.198.186:5001/stream/'+stat.id} alt='' style={{ width: '100%'}}/>
								</CardBody>
							</Card>
						</div>
						)
					)} */}
				</div>
			): null}
    	</div>
	)
	}
}

export default LivePeopleDetection